import { NgModule } from '@angular/core';

import { CmpsCommitmentBadgeContainerComponent } from './commitment-badge-container.component';
import { CmpsCommitmentBadgeComponent } from './commitment-badge.component';

@NgModule({
    declarations: [
        CmpsCommitmentBadgeContainerComponent,
        CmpsCommitmentBadgeComponent,
    ],
    exports: [
        CmpsCommitmentBadgeContainerComponent,
        CmpsCommitmentBadgeComponent,
    ],
})
export class CmpsCommitmentBadgeModule {}
